import * as adapters from "@/shared/forms";
import type { FormAdapters } from "@/shared/forms/types";
import type { Fields, FormValueEventInstance, FormValues, FormValuesEvent, FormValuesEvents } from "./types";

export type { Fields, FormValueEventInstance, FormValues, FormValuesEvent, FormValuesEvents };

export interface SubmitMeta {
    dontShowSearchAssistAgain: boolean | null;
}

const typedAdapters = {
    Form: adapters.Form,
    Field: adapters.Field,
    ArrayField: adapters.ArrayField,
    useFormAPI: adapters.useFormAPI,
    useFormStore: adapters.useFormStore,
    useFieldRefs: adapters.useFieldRefs,
    Subscribe: adapters.Subscribe,
} as unknown as FormAdapters<FormValues, SubmitMeta>;

// Explicit type annotations required to avoid TS7056 error when emitting declarations.
// TypeScript cannot serialize the inferred type of destructured exports from FormAdapters<FormValues>.

export const Form: FormAdapters<FormValues, SubmitMeta>["Form"] = typedAdapters.Form;
export const Field: FormAdapters<FormValues, SubmitMeta>["Field"] = typedAdapters.Field;
export const ArrayField: FormAdapters<FormValues, SubmitMeta>["ArrayField"] = typedAdapters.ArrayField;
export const useFormAPI: FormAdapters<FormValues, SubmitMeta>["useFormAPI"] = typedAdapters.useFormAPI;
export const useFormStore: FormAdapters<FormValues, SubmitMeta>["useFormStore"] = typedAdapters.useFormStore;
export const useFieldRefs: FormAdapters<FormValues, SubmitMeta>["useFieldRefs"] = typedAdapters.useFieldRefs;
export const Subscribe: FormAdapters<FormValues, SubmitMeta>["Subscribe"] = typedAdapters.Subscribe;

export { getEmptyFormValues, EVENT_DEFAULT_INSTANCE, RELATION_DEFAULT_INSTANCE } from "./utils";
export { useEventInstance } from "./useEventInstance";
export { useYearRangeToggle } from "./useYearRangeToggle";
export { yearRangePubSub } from "./yearRangePubSub";
